<template>
  <div v-if="canControl">
    <router-link
      v-if="canOpen"
      class="button is-small is-text"
      :to="{name: 'dataLinkDetails', params: {id: rowData.created}}"
    >
      Open
    </router-link>
    <button
      class="button is-small is-text"
      @click="clickDelete"
    >
      Delete
    </button>
  </div>
</template>

<script>
import WarningModal from '../modal/Warning'
import { mapActions } from 'vuex'

const INITIAL = 'initial'
const DONE = 'done'

export default {
  props: ['rowData'],
  computed: {
    canOpen () {
      return this.rowData.status !== INITIAL
    },
    canControl () {
      return this.rowData.status === DONE
    }
  },
  methods: {
    ...mapActions('datalink', [
      'deleteHistory'
    ]),
    clickDelete () {
      this.$modal.open({
        parent: this,
        component: WarningModal,
        canCancel: ['escape']
      })
    },
    deleteRecord () {
      this.deleteHistory(this.rowData.created)
    }
  }
}
</script>
